import { AnswerFormat, HeightAnswerFormat, TextChoiceAnswerFormat, TextChoiceDefinition, TimeOfDayAnswerFormat, ValuePickerAnswerFormat, WeightAnswerFormat } from "../../../types/Survey";
import { isMatch, isValid, parseISO } from "date-fns";
import { format24HTimeToTimeAnswer, formatDateToTimeAnswer } from "./timeHelpers";
import { QuestionResultModel, ResultModel, ResultType } from "../../../types/SurveyResult";

export function getDefaultSurveyQuestionResult(identifier: string, answerFormat?: AnswerFormat): ResultModel {
    if (!answerFormat) {
        return {
            Type: "QuestionResult",
            Identifier: identifier,
            Answer: "viewed"
        } as QuestionResultModel;
    }

    if (answerFormat.type === "FileAnswerFormat") {
        return {
            Type: "FileResult",
            Identifier: identifier
        };
    }

    if (answerFormat.type === "TextChoiceAnswerFormat" || answerFormat.type === "ValuePickerAnswerFormat") {
        let defaultSingleChoice = undefined;
        let choices: TextChoiceDefinition[] = [];
        if (answerFormat.type === "TextChoiceAnswerFormat") {
            let textChoiceAnswerFormat = answerFormat as TextChoiceAnswerFormat;
            choices = textChoiceAnswerFormat.textChoices;
        } else if (answerFormat.type === "ValuePickerAnswerFormat") {
            let valuePickerAnswerFormat = answerFormat as ValuePickerAnswerFormat;
            choices = valuePickerAnswerFormat.textChoices;
        }

        if (answerFormat.defaultValue && choices.find(t => t.value == answerFormat.defaultValue)) {
            defaultSingleChoice = answerFormat.defaultValue;
        }

        return {
            Type: "QuestionResult",
            Identifier: identifier,
            Choices: defaultSingleChoice ? [defaultSingleChoice] : []
        } as QuestionResultModel;
    }

    let defaultAnswer = answerFormat.defaultValue || "";
    if (answerFormat.type === "NumericAnswerFormat" ||
        answerFormat.type === "WeightAnswerFormat" ||
        answerFormat.type === "ScaleAnswerFormat" ||
        answerFormat.type === "ContinuousScaleAnswerFormat" ||
        answerFormat.type === "HeightAnswerFormat") {
        if (Number.isNaN(parseFloat(defaultAnswer))) {
            defaultAnswer = "";
        }
    }

    if (answerFormat.type === "DateAnswerFormat") {
        if (defaultAnswer) {
            let parsedDate = parseISO(defaultAnswer);
            if (!isValid(parsedDate)) {
                defaultAnswer = "";
            }
        }
    }

    if (answerFormat.type === "TimeOfDayAnswerFormat") {
        if (!isMatch(defaultAnswer, "hh:mm a")) {
            if (isMatch(defaultAnswer, "HH:mm")) {
                defaultAnswer = format24HTimeToTimeAnswer(defaultAnswer);
            } else {
                defaultAnswer = "";
            }
        }

        let timeOfDayAnswerFormat = answerFormat as TimeOfDayAnswerFormat;
        if (!defaultAnswer && timeOfDayAnswerFormat.defaultHour !== undefined) {
            let date = new Date();
            date.setHours(timeOfDayAnswerFormat.defaultHour);
            date.setMinutes(timeOfDayAnswerFormat.defaultMinute || 0);
            defaultAnswer = formatDateToTimeAnswer(date);
        }
    }

    if (answerFormat.type === "BooleanAnswerFormat") {
        if (defaultAnswer) {
            const lowerValue = String(defaultAnswer).toLowerCase();
            if (lowerValue === "true" || lowerValue === "yes" || lowerValue === "1") {
                defaultAnswer = "True";
            } else if (lowerValue === "false" || lowerValue === "no" || lowerValue === "0") {
                defaultAnswer = "False";
            }
        }
    }

    return {
        Type: "QuestionResult",
        Identifier: identifier,
        Answer: defaultAnswer
    } as QuestionResultModel;
}
